import classNames from 'classnames';
import React from 'react';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
}

const TopicHeader: React.FC<IProps> = ({ className = '', children, ...restProps }) => {
  return (
    <div
      className={classNames(
        'shadow-border z-40 flex items-center justify-between bg-white p-2 sm:px-4 md:px-8 md:py-4',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default TopicHeader;
